import axios from "axios";
import {API_BASE_URL_V2} from "../../../services/config";
import {
  normalizeV2CoachAuthResponse,
  normalizeV2CustomerAuthResponse,
} from "../auth-normalizer";

// Activate standard user
export const activateStandardUserService = async (link: string) => {
  // PATCH /auth/activate-account?token={token}
  const response = await axios.patch(
    `${API_BASE_URL_V2}auth/activate-account?token=${encodeURIComponent(link)}`
  );
  const result = response.data;
  return {...result, data: normalizeV2CoachAuthResponse(result.data)};
};
// Resend Activation link
export const resendActivationLinkService = async (email: string) => {
  const normalizedEmail = email.toLowerCase();

  // GET /auth/resend-activation-link/:email
  const response = await axios.get(
    `${API_BASE_URL_V2}auth/resend-activation-link/${encodeURIComponent(normalizedEmail)}`
  );
  return response.data;
};

export const activateCustomerService = async (link: string) => {
  // POST customers/auth/confirm (body: {token})
  const response = await axios.post(API_BASE_URL_V2 + "customers/auth/confirm", {
    token: link,
  });
  const result = response.data;
  return {...result, data: normalizeV2CustomerAuthResponse(result.data)};
};
